import React, { useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signInWithEmailAndPassword
} from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { auth, db } from "../../utils/firebase";
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where
} from "firebase/firestore";
import { collectionNames, routes } from "../../utils/Constants";

const SignUp = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [confirmPwd, setConfimPwd] = useState("");

  const signUpHandler = async () => {
    if (!email || !pwd || !name) return alert("Fill All details");
    if (pwd != confirmPwd) return alert("Passwords doesnt match");

    await createUserWithEmailAndPassword(auth, email, pwd)
      .then(async (userCredential) => {
        const docRef = await setDoc(doc(db, collectionNames.STAFFS, email), {
          name,
          authSet: true,
          email
        });
        navigate("/");

        // ...
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  return (
    <div className="relative flex flex-col justify-center min-h-screen overflow-hidden">
      <div className="w-full p-6 m-auto bg-white rounded-md shadow-md lg:max-w-lg">
        <h1 className="text-3xl font-semibold text-center text-primary underline">
          Sign Up
        </h1>
        <div className="mt-6">
          <div className="mb-2">
            <label
              for="name"
              className="block text-sm font-semibold text-gray-800"
            >
              Name
            </label>
            <input
              type="text"
              className="block w-full px-4 py-2 mt-2 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="mb-2">
            <label
              for="email"
              className="block text-sm font-semibold text-gray-800"
            >
              Email
            </label>
            <input
              type="email"
              className="block w-full px-4 py-2 mt-2 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="mb-2">
            <label
              for="password"
              className="block text-sm font-semibold text-gray-800"
            >
              Password
            </label>
            <input
              type="password"
              className="block w-full px-4 py-2 mt-2 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
              onChange={(e) => setPwd(e.target.value)}
            />
          </div>

          <div className="mb-2">
            <label
              for="password"
              className="block text-sm font-semibold text-gray-800"
            >
              Confirm Password
            </label>
            <input
              type="password"
              className="block w-full px-4 py-2 mt-2 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
              onChange={(e) => setConfimPwd(e.target.value)}
            />
          </div>

          {/* {authSet == true && (
            <a
              href="#"
              className="text-xs text-primary hover:underline"
              onClick={triggerPwdResetEmail}
            >
              Forgot Password?
            </a>
          )} */}
          <div className="mt-6">
            <button
              onClick={signUpHandler}
              className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-primary rounded-md hover:bg-background focus:outline-none focus:bg-primary"
            >
              Sign Up
            </button>
          </div>
        </div>
        <p class="text-center text-sm mt-3">
          Alread registered?{" "}
          <span
            class="text-primary cursor-pointer"
            onClick={() => navigate(routes.LOGIN)}
          >
           Login
          </span>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
